export const WA_NUMBER = "4916099007777";

export const WA_TEXT =
  "Hallo NENOX, ich interessiere mich für eine Dienstleistung und möchte gerne ein unverbindliches Angebot erhalten.";

export const waLink = (text = WA_TEXT) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
